import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import { PureComponent } from '../component';
import shallowEqual from '../utils/shallowEqual';
import utils from './utils';
import { getLocale } from '../locale';
import paramUtils from './paramUtils';
import Picker from './Picker';
import { datepickerClass } from './styles';
import Quick from './Quick';
var DefaultValue = {
  value: []
};

var Range =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Range, _PureComponent);

  var _super = _createSuper2(Range);

  function Range(props) {
    var _this;

    _classCallCheck(this, Range);

    _this = _super.call(this, props);
    _this.pickers = void 0;
    _this.handleFirstChange = void 0;
    _this.handleSecondChange = void 0;
    _this.bindFirstPicker = void 0;
    _this.bindSecondPicker = void 0;
    _this.handleDisabledStart = void 0;
    _this.handleDisabledEnd = void 0;
    _this.state = {
      rangeDate: props.value
    };
    _this.pickers = [];
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleFirstChange = _this.handleChange.bind(_assertThisInitialized(_this), 0);
    _this.handleSecondChange = _this.handleChange.bind(_assertThisInitialized(_this), 1);
    _this.handleDayHover = _this.handleDayHover.bind(_assertThisInitialized(_this));
    _this.bindFirstPicker = _this.bindPicker.bind(_assertThisInitialized(_this), 0);
    _this.bindSecondPicker = _this.bindPicker.bind(_assertThisInitialized(_this), 1);
    _this.handleDisabledStart = _this.handleDisabled.bind(_assertThisInitialized(_this), 'start');
    _this.handleDisabledEnd = _this.handleDisabled.bind(_assertThisInitialized(_this), 'end');
    _this.changeDateSmart = _this.changeDateSmart.bind(_assertThisInitialized(_this));
    _this.handleQuick = _this.handleQuick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Range, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var rangeDate = this.state.rangeDate;

      if (rangeDate.length !== 1 && !shallowEqual(prevProps.value, this.props.value) && !shallowEqual(this.state.rangeDate, this.props.value)) {
        // eslint-disable-next-line
        this.setState({
          rangeDate: this.props.value
        });
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var timeZone = this.props.timeZone;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "bindPicker",
    value: function bindPicker(index, el) {
      this.pickers[index] = el;
    }
  }, {
    key: "resetRange",
    value: function resetRange(rangeDate) {
      this.setState({
        rangeDate: rangeDate
      });
    }
  }, {
    key: "handleDayHover",
    value: function handleDayHover(date) {
      // will never in
      if (this.state.rangeDate.length === 1) {
        utils.cloneTime(date, this.props.value[1], this.props.format, this.getOptions()); // this.setState({ hover: date })
      }
    }
  }, {
    key: "changeDateSmart",
    value: function changeDateSmart(rangeDate) {
      if (!rangeDate[0] || !rangeDate[1]) return;

      var _rangeDate = _slicedToArray(rangeDate, 2),
          s = _rangeDate[0],
          e = _rangeDate[1];

      var range = this.props.range;

      if (typeof range === 'number') {
        if (utils.compareAsc(s, utils.addSeconds(e, -range, this.getOptions())) < 0) rangeDate[1] = utils.addSeconds(s, range, this.getOptions());
      }

      if (utils.compareAsc(s, e) > 0) {
        var sWitheTime = utils.toDate(s, this.getOptions());
        sWitheTime = utils.setTime(sWitheTime, e, this.getOptions());
        rangeDate[1] = utils.compareAsc(s, sWitheTime) > 0 ? s : sWitheTime;
      }
    } // Be consistent with the parent onChange, expand first params: index

  }, {
    key: "handleChange",
    value: function handleChange(index, date, change, _blur, _isEnd, _isQuickSelect, areaType) {
      var _this2 = this;

      var newDate = date ? utils.toDate(date, this.getOptions()) : '';
      var _this$props = this.props,
          type = _this$props.type,
          range = _this$props.range,
          min = _this$props.min,
          max = _this$props.max;
      var handleOnChangeParams = paramUtils.handleOnChangeParams(areaType);

      if (!change) {
        var _this$props2;

        var current = immer(this.props.current, function (draft) {
          draft[index] = newDate;
        });

        (_this$props2 = this.props).onChange.apply(_this$props2, _toConsumableArray(handleOnChangeParams(current)));

        return;
      }

      if (areaType === 'time') {
        var endChangedDate;
        this.setState(immer(function (draft) {
          draft.rangeDate[index] = newDate;

          var _draft$rangeDate = _slicedToArray(draft.rangeDate, 2),
              s = _draft$rangeDate[0],
              e = _draft$rangeDate[1];

          if (index !== 0) {
            if (s && s.getHours() === e.getHours()) {
              if (utils.compareAsc(s, e) === 1) {
                e.setMinutes(s.getMinutes());
              }
            }

            return;
          }

          if (range && utils.compareAsc(s, e) === 1) {
            endChangedDate = newDate;
            draft.rangeDate[1] = endChangedDate;
          }

          if (typeof range === 'number' && utils.compareAsc(s, utils.addSeconds(e, -range, _this2.getOptions())) < 0) {
            endChangedDate = utils.addSeconds(s, range, _this2.getOptions());
            draft.rangeDate[1] = endChangedDate;
          }
        }), function () {
          var _this2$props;

          var current = immer(_this2.props.value, function (draft) {
            draft[index] = newDate;
            if (endChangedDate) draft[1] = endChangedDate;
            draft[1 - index] = draft[1 - index] || '';
          });

          (_this2$props = _this2.props).onChange.apply(_this2$props, _toConsumableArray(handleOnChangeParams(current, true)));
        });
        return;
      }

      if (type === 'month') {
        var _this$props3;

        // eslint-disable-next-line
        var _rangeDate2 = _toConsumableArray(this.state.rangeDate);

        _rangeDate2[index] = newDate;
        _rangeDate2[1 - index] = _rangeDate2[1 - index] || '';
        this.changeDateSmart(_rangeDate2);
        this.setState({
          rangeDate: _rangeDate2
        });

        (_this$props3 = this.props).onChange.apply(_this$props3, _toConsumableArray(handleOnChangeParams(_rangeDate2, true, true, index === 1)));

        return;
      }

      newDate = utils.cloneTime(newDate, this.props.value[index], undefined, this.getOptions());

      if (min && utils.compareAsc(newDate, min) <= 0) {
        newDate = utils.setTime(newDate, min, this.getOptions());
      }

      if (max && utils.compareAsc(newDate, max) >= 0) {
        newDate = utils.setTime(newDate, max, this.getOptions());
      }

      this.setState(immer(function (draft) {
        draft.rangeDate[index] = newDate;
        draft.rangeDate[1 - index] = draft.rangeDate[1 - index] || '';

        _this2.changeDateSmart(draft.rangeDate);

        draft.hover = undefined;
      }), function () {
        var _this2$props2;

        // only 'datetime' don not need close, 'time is up'
        (_this2$props2 = _this2.props).onChange.apply(_this2$props2, _toConsumableArray(handleOnChangeParams(_this2.state.rangeDate, true, type !== 'datetime', index === 1)));
      });
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(type, date) {
      var disabled = this.props.disabled;
      var rangeDate = this.state.rangeDate;

      if (disabled) {
        return disabled.apply(void 0, [date, type].concat(_toConsumableArray(rangeDate)));
      }

      return false;
    }
  }, {
    key: "handleQuick",
    value: function handleQuick(quick) {
      var _this$props4;

      this.setState({
        rangeDate: quick.value
      });

      (_this$props4 = this.props).onChange.apply(_this$props4, _toConsumableArray(paramUtils.quickHandleChangeParams(quick.value, true, false, false, quick)));
    }
  }, {
    key: "render",
    value: function render() {
      // min & max can not to child
      var _this$props5 = this.props,
          current = _this$props5.current,
          value = _this$props5.value,
          range = _this$props5.range,
          children = _this$props5.children,
          min = _this$props5.min,
          max = _this$props5.max,
          quicks = _this$props5.quicks,
          props = _objectWithoutProperties(_this$props5, ["current", "value", "range", "children", "min", "max", "quicks"]);

      var rangeDate = _toConsumableArray(this.state.rangeDate);

      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('range-picker')
        },
        /*#__PURE__*/
        React.createElement(Quick, Object.assign({}, this.props, {
          current: this.state.rangeDate,
          onChange: this.handleQuick
        })),
        /*#__PURE__*/
        React.createElement(Picker, Object.assign({}, props, {
          pos: "start",
          disabled: this.handleDisabledStart,
          index: 0,
          min: min,
          max: max,
          current: current[0],
          range: typeof range === 'number' ? range : undefined,
          rangeDate: rangeDate,
          rangeTemp: rangeDate[0],
          onChange: this.handleFirstChange,
          onChangeSync: this.handleChange,
          onDayHover: this.handleDayHover,
          ref: this.bindFirstPicker,
          value: utils.toDateWithFormat(value[0], props.format, undefined, this.getOptions()),
          showTimePicker: value.length === 2
        })),
        /*#__PURE__*/
        React.createElement(Picker, Object.assign({}, props, {
          disabled: this.handleDisabledEnd,
          index: 1,
          min: rangeDate[0] ? rangeDate[0] : min,
          max: max,
          current: current[1],
          range: typeof range === 'number' ? range : undefined,
          rangeDate: rangeDate,
          rangeTemp: rangeDate[0],
          onChange: this.handleSecondChange,
          onChangeSync: this.handleChange,
          onDayHover: this.handleDayHover,
          ref: this.bindSecondPicker,
          value: utils.toDateWithFormat(value[1], props.format, undefined, this.getOptions()),
          showTimePicker: value.length === 2
        })))
      );
    }
  }]);

  return Range;
}(PureComponent);

Range.defaultProps = DefaultValue;
export default Range;